/* eslint-disable import/prefer-default-export */
export const imageBaseUrl = 'https://sbpv3-abs-images.s3.amazonaws.com';
